/**
 * Returns a react-icons icon name suggestion based on file extension.
 * Used to pick the right icon for FileMessage component.
 */

type FileCategory = 'image' | 'video' | 'audio' | 'pdf' | 'spreadsheet' | 'document' | 'archive' | 'code' | 'unknown'

const extensionMap: Record<string, FileCategory> = {
  // Images
  jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', svg: 'image', webp: 'image',
  // Video
  mp4: 'video', avi: 'video', mov: 'video', mkv: 'video', webm: 'video',
  // Audio
  mp3: 'audio', wav: 'audio', ogg: 'audio', flac: 'audio',
  // Documents
  pdf: 'pdf',
  doc: 'document', docx: 'document', txt: 'document', rtf: 'document',
  xls: 'spreadsheet', xlsx: 'spreadsheet', csv: 'spreadsheet',
  ppt: 'document', pptx: 'document',
  // Archives
  zip: 'archive', rar: 'archive', '7z': 'archive', tar: 'archive', gz: 'archive',
  // Code
  js: 'code', ts: 'code', jsx: 'code', tsx: 'code', py: 'code', json: 'code', html: 'code', css: 'code',
  // Design
  figma: 'document', sketch: 'document', psd: 'image',
}

export function getFileCategory(filename: string): FileCategory {
  const ext = filename.split('.').pop()?.toLowerCase() ?? ''
  return extensionMap[ext] ?? 'unknown'
}

/**
 * Format file size from bytes to human-readable string.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}
